import React from "react";
import { NOT_STARTED } from "../constants";
import type { Check, Checks } from "../constants";
import StatusIcon from "./StatusIcon";

const connectorColor = (check?: Check) =>
  check?.status === "pass" ? "bg-primary" : check?.status === "fail" ? "bg-red-300" : "bg-gray-200";

const CheckJourney: React.FC<{
  title: string;
  items: { key: string; label: string }[];
  checks: Checks;
  vertical?: boolean;
}> = ({ title, items, checks, vertical = false }) => (
  <div className="bg-white rounded-2xl border border-gray-100 p-5">
    <h3 className="text-lg font-bold text-gray-800 mb-4">{title}</h3>
    {vertical ? (
      <ol>
        {items.map(({ key, label }, i) => {
          const check = checks[key] ?? NOT_STARTED;
          const isLast = i === items.length - 1;
          return (
            <li key={key} className="flex gap-3">
              <div className="flex flex-col items-center">
                <StatusIcon status={check.status} />
                {!isLast && <div className={`flex-1 w-0.5 ${connectorColor(check)}`} />}
              </div>
              <div className={`min-w-0 ${isLast ? "" : "pb-6"}`}>
                <p className="font-semibold text-gray-800 text-sm">{label}</p>
                <p
                  className={`text-xs mt-0.5 ${check.status === "fail" ? "text-red-600" : "text-gray-500"}`}
                >
                  {check.detail}
                </p>
              </div>
            </li>
          );
        })}
      </ol>
    ) : (
      <div className="overflow-x-auto">
        <ol className="flex items-start min-w-[640px]">
          {items.map(({ key, label }, i) => {
            const check = checks[key] ?? NOT_STARTED;
            const previous = i > 0 ? checks[items[i - 1].key] : undefined;
            return (
              <li key={key} className="flex-1 flex flex-col items-center">
                <div className="flex items-center w-full">
                  <div className={`flex-1 h-0.5 ${i === 0 ? "invisible" : connectorColor(previous)}`} />
                  <StatusIcon status={check.status} />
                  <div
                    className={`flex-1 h-0.5 ${i === items.length - 1 ? "invisible" : connectorColor(check)}`}
                  />
                </div>
                <p className="font-semibold text-gray-800 text-sm mt-2 text-center px-2">{label}</p>
                <p
                  className={`text-xs mt-0.5 text-center px-2 ${check.status === "fail" ? "text-red-600" : "text-gray-500"}`}
                >
                  {check.detail}
                </p>
              </li>
            );
          })}
        </ol>
      </div>
    )}
  </div>
);

export default CheckJourney;
